class HomewareFloatingCart {

  constructor() {

    this.bar = document.getElementById('hw-floating-cart');

    if(!this.bar) return;

    this.qty = document.getElementById('hw-cart-qty');
    this.total = document.getElementById('hw-cart-total');

    this.loadCart();

    document.addEventListener('cart:refresh', () => {
      this.loadCart();
    });

    setInterval(() => {
      this.loadCart();
    },1000);

    this.bar.addEventListener('click', () => {

      const drawer =
      document.querySelector('cart-drawer');

      if(drawer){
        drawer.open();
      }else{
        window.location.href='/cart';
      }

    });

  }

  async loadCart(){

    try{

      const response =
      await fetch('/cart.js');

      const cart =
      await response.json();

      this.qty.textContent =
      cart.item_count;

      this.total.textContent =
      this.total.textContent =
'₹' + (cart.total_price / 100).toLocaleString('en-IN');

      if(cart.item_count > 0){

        this.bar.classList.add('active');

      }else{

        this.bar.classList.remove('active');

      }

    }catch(e){
      console.log(e);
    }

  }

}

document.addEventListener(
'DOMContentLoaded',
() => {
  new HomewareFloatingCart();
});